// The search over code, subject, sender name and sender email, shared by every conversation picker.
// `input` is the typed text; the select lib types it loosely as a record, a caller with a string passes it as is.
export const buildConversationSearch = (input: string | Record<any, any>) => ({
  $or: [
    { code: { $regex: input, $options: 'i' } },
    { subject: { $regex: input, $options: 'i' } },
    { 'sender.profile.name': { $regex: input, $options: 'i' } },
    { 'sender.profile.email': { $regex: input, $options: 'i' } },
  ],
})
